import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useSession } from 'src/hooks';
import { ToggleSwitch } from 'src/common/toggle-switch';
import { changeEmailSubscription } from 'src/actions/userSettingsActions';
import styles from './EmailNotification.module.scss';

const EmailNotification = () => {
  const dispatch = useDispatch();
  const { user } = useSession();

  const [checked, setChecked] = useState(user.settings.subscribedToEmail);

  const handleSubmit = useCallback(() => {
    const data = { subscribedToEmail: !checked };
    dispatch(changeEmailSubscription(data));
    setChecked(!checked);
  }, [checked, dispatch]);

  return (
    <div className={styles.container}>
      <div className={styles.headerInfo}>Email Notifications</div>
      <div className={styles.notificationsSwitch}>
        <span className={styles.text}>Receive emails from Stagger on your account and updates</span>
        <ToggleSwitch checked={checked} onChange={handleSubmit} />
      </div>
    </div>
  );
};

export { EmailNotification };
